export async function fetchAllPaginated<TResponse, TItem>(
  fetchPage: (pageInfo?: string) => Promise<TResponse>,
  getItems: (response: TResponse) => TItem[],
  getNextKey: (response: TResponse) => string | undefined
): Promise<TItem[]> {
  const allItems: TItem[] = [];
  let nextKey: string | undefined = undefined;

  while (true) {
    const response = await fetchPage(nextKey);
    const items = getItems(response);
    if (Array.isArray(items) && items.length > 0) {
      allItems.push(...items);
    }
    nextKey = getNextKey(response);
    if (!nextKey) break;
  }

  return allItems;
}

/**
 * Calculates total pages based on total count and page size
 * @param totalCount - Total number of items
 * @param pageSize - Number of items per page
 * @returns Calculated total pages (0 if totalCount is 0)
 */
export function calculateTotalPages(totalCount: number, pageSize: number): number {
  if (!totalCount || totalCount === 0 || !pageSize || pageSize === 0) return 0;
  return Math.ceil(totalCount / pageSize);
}
